import { LearnerMixedContentListItem } from "../../../apps/user/learner/api/types";
import { CardItemType } from "./ContentCard";

export function extractItem(item: LearnerMixedContentListItem): CardItemType {
  if (item.__typename === "LearnerRecording") {
    return {
      ...item,
      __typename: "LearnerRecording",
      subtitle: item.practitioner?.fullName || item.subtitle || "",
      tags: [...(item.topic ? [item.topic] : [])],
      duration: item.videoDurationText || item.sessionDuration || "",
      link: `/user/recordings/${item.id}`,
    };
  }
  if (item.__typename === "LearnerArticle") {
    return {
      ...item,
      __typename: "LearnerArticle",
      tags: [item.pillarLabel].filter(Boolean),
      duration: item.readTime || "",
      link: `/user/articles/${item.id}`,
    };
  }
  if (item.__typename === "LearnerGroupSession") {
    return {
      ...item,
      tags: [...(item.topic ? [item.topic] : [])],
      link: `/user/sessions/group/${item.id}`,
      __typename: "LearnerGroupSession",
      duration: "",
    };
  }
  throw new Error("Unsupported __typename");
}
